<script>
  import {quantity} from "./store";

	export let coveragePrice='', availability='', lang='', dataset='', formatMoney='';

	if(dataset.tenantHhSellingUom == 'CT') {
		dataset.tenantHhSellingUom = lang == 'en' ? 'case' : 'caisse';
	}

	let coverageFormState = {
		requiredCoverage: '',
		coverageBuffer: 5,
		coverageBufferCheck: true,
		calculationType: 'lengthWidthCalculation',
		requiredCoverageLengthWidth: '',
	};

	let resultCoverageArea = false;
	let calculatedCoverage = {
		area: 0,
		nonBufferArea: 0,
		qty: 0,
		buffer: 0
	};

	function coverageProductQtyCalculator(e) {
		if(coverageFormState.calculationType == 'lengthWidthCalculation') {
			//let totalArea = 0;
			lengthWidthAreas = calculatedLengthWidthAreas = lengthWidthAreas.filter(area => +area.length && +area.width);
			const totalArea = calculatedLengthWidthAreas
				.map(area => parseFloat(area.length) * parseFloat(area.width))
				.reduce((acc, area) => acc + area, 0);

			if (totalArea)	coverageFormState.requiredCoverageLengthWidth = totalArea;
			calculatedCoverage.nonBufferArea = calculatedCoverage.area = parseFloat(coverageFormState.requiredCoverageLengthWidth);
		} else if (coverageFormState.calculationType == 'directCalculation') {
			sqFtAreas = sqFtAreas.filter(area => +area);
			const totalArea = sqFtAreas.map(area => parseFloat(area))
				.reduce((acc, area) => acc + area, 0);
			//coverageFormState.requiredCoverage = parseFloat(coverageFormState.requiredCoverage);
			if(!sqFtAreas.length) return;		
			calculatedCoverage.nonBufferArea = calculatedCoverage.area = totalArea;
		}

		coverageFormState.coverageBuffer = parseFloat(coverageFormState.coverageBuffer);
		if (coverageFormState.coverageBufferCheck) {
			calculatedCoverage.area = parseFloat(calculatedCoverage.area * (1 + (coverageFormState.coverageBuffer / 100)));
		}
		calculatedCoverage.qty = $quantity = Math.ceil(calculatedCoverage.area / parseFloat(coveragePrice));
		calculatedCoverage.total = calculatedCoverage.qty * parseFloat(coveragePrice);
		calculatedCoverage.buffer = coverageFormState.coverageBufferCheck ? coverageFormState.coverageBuffer : 0;

		resultCoverageArea = true;
	}

	function requiredCoverageHandler(e) {
		const areaIndex = e.target.dataset.index;
		if (coverageFormState.calculationType == 'lengthWidthCalculation') {
			//resultCoverageArea = false;
			if (e.target.id.includes('length')) {
				lengthWidthAreas[areaIndex].length = e.target.value.replace(/[^0-9.]/g, '').replace(/^([^.]*\.)|\./g, '$1')
			} else if (e.target.id.includes('width')) {
				lengthWidthAreas[areaIndex].width = e.target.value.replace(/[^0-9.]/g, '').replace(/^([^.]*\.)|\./g, '$1')
			}
			return
		}
		sqFtAreas[areaIndex] = e.target.value.replace(/[^0-9.]/g, '').replace(/^([^.]*\.)|\./g, '$1')
	}

	let lengthWidthAreas = [{ length: '', width: '' }];
	let sqFtAreas = [''];
	let calculatedLengthWidthAreas = [];

	function addNewArea() {
		if(coverageFormState.calculationType == 'lengthWidthCalculation'){
			lengthWidthAreas = [...lengthWidthAreas, { length: '', width: '' }];
		} else if (coverageFormState.calculationType == 'directCalculation') {
			sqFtAreas = [...sqFtAreas, ''];
		}
	}

	function handleCalculationChange(e) {
		if(resultCoverageArea) {
			coverageFormState.requiredCoverage = ''
			coverageFormState.coverageBuffer = 5
			coverageFormState.coverageBufferCheck = true
			coverageFormState.requiredCoverageLengthWidth = ''
			lengthWidthAreas = [{ length: '', width: '' }];
			calculatedLengthWidthAreas = []
			sqFtAreas = ['']
			calculatedCoverage = {
				area: 0,
				nonBufferArea: 0,
				qty: 0,
				buffer: 0
			}
		}
		resultCoverageArea = false;
		$quantity = 1;

	}


	$: disableCalculate = sqFtAreas.filter(area=> +area).length < 1;	
	$: disableLengthWidthCalculate = lengthWidthAreas.filter(area => +area.length && +area.width).length < 1;
</script>

<section class="SquareFootageCalculator">
	<details class="Accordion-Overview">
		<summary class="h4">
			<img class="Icon Bigger" src="https://homehardware.sirv.com/hh/icons/icon-calculator.darkgrey.svg" alt="calculator icon" width="10" height="10" loading="lazy" >
			{ lang == 'en'
				? 'Square Footage Calculator'
				: 'Calculateur de superficie'
			}
		</summary>
		<p>
			{#if coverageFormState.calculationType == 'lengthWidthCalculation'}
				{lang == 'en'
					? `To measure your square footage, enter the width and length of your project area. For rooms with alcoves or pop-outs, measure each section separately then click ‘Add Area’ to include in the calculation.`
					: `Pour mesurer votre superficie, entrez la largeur et la longueur de votre projet de zone area. Pour les salles avec alcôves ou fenêtres largables, mesurez chaque section séparément, puis cliquez sur « Ajouter une zone » pour l’inclure dans le calcul.`
				}
				{:else if coverageFormState.calculationType == 'directCalculation'}
				{lang == 'en'
					? `Enter the square footage of your space to calculate how many cases you'll need. For rooms with alcoves or pop-outs, measure each section separately then click ‘Add Area’ to include in the calculation.`
					: `Entrez la superficie en pieds carrés de votre espace pour calculer le nombre de caisses dont vous aurez besoin. Pour les salles avec alcôves ou fenêtres largables, mesurez chaque section séparément, puis cliquez sur « Ajouter une zone » pour l’inclure dans le calcul.`
			}
			{/if}
		</p>
		<form class="Form" on:submit|preventDefault={coverageProductQtyCalculator}>
			<fieldset class="FormColumns">
				<label for="length_x_width">
					<input type="radio" id="length_x_width" name="calculation_type" bind:group={coverageFormState.calculationType} value="lengthWidthCalculation" on:input={handleCalculationChange}/>
					{ lang == 'en'
						? `Enter Length x Width`
						: `Entrez la longueur x la largeur`
					}
				</label>
				<label for="enter_square_feet" >
					<input type="radio" id="enter_square_feet" name="calculation_type" bind:group={coverageFormState.calculationType} value="directCalculation" on:input={handleCalculationChange}/>
					{ lang == 'en'
						? `Enter Square Feet`
						: `	Entrez les pieds carrés`
					}
				</label>
			</fieldset>
			{#if coverageFormState.calculationType == 'lengthWidthCalculation'}
			<fieldset class="LengthWidthAreas">
				{#each lengthWidthAreas as area, index}
					<label for={`coverage_input_length_${index + 1}`}>
						{lang == 'en' ? 'Area' : 'Zone'} {index + 1}
						{
							calculatedLengthWidthAreas.length > 1 && calculatedLengthWidthAreas[index]?.length && calculatedLengthWidthAreas[index]?.width
							? ` - ${parseFloat(calculatedLengthWidthAreas[index].length) * parseFloat(calculatedLengthWidthAreas[index].width)} ${lang == 'en' ? 'Square Feet' : 'pieds carrés'}`
							: ''
						}
					</label>
					<fieldset>
						<input
							class="InputWide"
							type="text"
							name="coverage"
							id={`coverage_input_length_${index + 1}`}
							data-index = {index}
							on:input={requiredCoverageHandler} 
							bind:value={area.length}
							placeholder={lang == 'en' ? 'Length' : 'Longueur'}
						>
						<span class="h3 Light">&times;</span>
						<input
							class="InputWide"
							type="text"
							name="coverage"
							id={`coverage_input_width_${index + 1}`}
							data-index = {index}
							on:input={requiredCoverageHandler} 
							bind:value={area.width}
							placeholder={lang == 'en' ? 'Width' : 'Largeur'}
						>
					</fieldset>
				{/each}
				<button class="Underline" type="button" on:click={addNewArea}>{ lang == 'en' ? '+ Add Area' : '+ Ajouter une zone'}</button>
			
			</fieldset>
			{:else if coverageFormState.calculationType == 'directCalculation'}	
				<fieldset class="SquareFootageAreas">
					{#each sqFtAreas as area, index}
						<label for={`coverage_input_${index + 1}`}>{lang == 'en' ? `Area ${index + 1}` : `Zone ${index + 1}`}</label>
						<fieldset>
							<input class="InputWide" type="text" name="coverage" id={`coverage_input_${index + 1}`} data-index = {index} bind:value={area} on:input={requiredCoverageHandler} placeholder={lang == 'en' ? 'Total Square Footage' : 'Superficie totale en pieds carrés'} >
						</fieldset>
					{/each}
					<button class="Underline" type="button" on:click={addNewArea}>{ lang == 'en' ? '+ Add Area' : '+ Ajouter une zone'}</button>
				</fieldset>
			{/if}

			<fieldset class="CalculatorAdditions">
				<!-- svelte-ignore a11y-label-has-associated-control -->
				<label>
					<input type="checkbox" name="buffer_check" bind:checked={coverageFormState.coverageBufferCheck} id="buffer_check">
					{ lang == 'en'
						? `Add additional flooring for cuts and waste (5% recommended)`
						: `Ajouter un revêtement de sol supplémentaire pour les coupes et les déchets (5 % recommandé)`
					}

					<fieldset class="RadioFlex">
						<label>
							<input type="radio" name="buffer_percentage" bind:group={coverageFormState.coverageBuffer} value={2.5} checked="">2.5%
						</label>
						<label >
							<input type="radio" name="buffer_percentage" bind:group={coverageFormState.coverageBuffer} value={5} checked="">5%
						</label>
						<label >
							<input type="radio" name="buffer_percentage" bind:group={coverageFormState.coverageBuffer} value={7.5}>7.5%
						</label>
						<label >
							<input type="radio" name="buffer_percentage" bind:group={coverageFormState.coverageBuffer} value={10}>10%
						</label>


						<!-- <input class="InputWide" type="text" name="coverage_buffer" bind:value={coverageFormState.coverageBuffer} disabled={!coverageFormState.coverageBufferCheck} on:input={(e) => e.target.value = e.target.value.replace(/\D/g, '').slice(0, 3)}>
						{ lang == 'en'
							? `% for cuts and wastage (recommended)`
							: `% supplémentaires pour les coupes et le gaspillage (recommandé)`
						} -->
					</fieldset>
				</label>
			</fieldset>
			<button class="Button ButtonSecondary" type="submit" disabled={coverageFormState.calculationType == 'lengthWidthCalculation' ? disableLengthWidthCalculate : disableCalculate}>{lang =='en' ? 'Calculate' : 'Calculer'}</button>
		</form>
		{#if resultCoverageArea}
			<section class="Calculated">
				<table class="TableKeyValues">
					<tbody>
						<tr>
							<td>{@html lang == 'en' ? 'Total Sq. Ft' :'Total pi<sup>2</sup> '}:</td>
							<td>
								{lang== 'en' ? calculatedCoverage.nonBufferArea.toFixed(2) :calculatedCoverage.nonBufferArea.toFixed(2).toString().replace(/\./g, ',')} {lang == 'en' ? 'Sq Ft' : 'pieds carrés'}
							</td>
						</tr>
						{#if calculatedCoverage.buffer}
							<tr>
								<td>{lang == 'en' ? 'Waste or Extra' : 'Perte ou excédent '}:</td>
								<td>{lang == 'en' ? parseFloat(calculatedCoverage.nonBufferArea * (calculatedCoverage.buffer /100)).toFixed(2) : parseFloat(calculatedCoverage.nonBufferArea * (calculatedCoverage.buffer /100)).toFixed(2).toString().replace(/\./g, ',')} {lang == 'en' ? 'Sq Ft' : 'pieds carrés'}</td>
							</tr>
						{/if}
						<tr>
							<td>{lang == 'en' ? 'Total Quantity':'Quantité totale '}:</td>
							<td>{calculatedCoverage.qty} {dataset.tenantHhSellingUom == 'case' ? 'Case' : dataset.tenantHhSellingUom}{calculatedCoverage.qty > 1 ? `s` : ''}
							{lang == 'en' 
								? `, Covers ${calculatedCoverage.total.toFixed(2)} Sq Ft. ${calculatedCoverage.buffer ? ` (includes ${calculatedCoverage.buffer}%)` : ''}`
								: `couvrent ${calculatedCoverage.total.toFixed(2).toString().replace(/\./g, ',')} pieds carrés. ${calculatedCoverage.buffer ? ` (comprend ${calculatedCoverage.buffer}%)` : ''}`
							}</td>
						</tr>
						<tr>
							<td>
								<strong>{lang == 'en' ? 'Total Price':'Prix total '}:*</strong><small >*{lang == 'en' ? 'This is an estimate': 'Ceci est une estimation'}</small>
							</td>
							<td>
								<span class="h3">
									{formatMoney(calculatedCoverage.qty * (availability.price.salePrice || availability.price.price))}
								</span>
								{ lang == 'en'
									? ` for ${calculatedCoverage.qty} ${dataset.tenantHhSellingUom}${calculatedCoverage.qty > 1 ? `s` : ''}`
									: ` pour ${calculatedCoverage.qty} ${dataset.tenantHhSellingUom}${calculatedCoverage.qty > 1 ? `s` : ''}`
								}
							</td>
						</tr>
					</tbody>
				</table>
				{#if calculatedCoverage.qty > availability.maxQty}
					<div>
						<p class="ErrorNote">
							{ lang == 'en'
								? ` Only ${availability.maxQty } ${dataset.tenantHhSellingUom}${calculatedCoverage.qty > 1 ? `(s)` : ''} left. Call your local store for details.`
								: `Il ne reste que ${availability.maxQty} ${dataset.tenantHhSellingUom}${calculatedCoverage.qty > 1 ? `(s)` : ''}. Appelez votre magasin local pour plus de détails.`
							}
						</p>
					</div>
				{/if}
				<!-- <p>
					<strong>{calculatedCoverage.qty} {dataset.tenantHhSellingUom}{calculatedCoverage.qty > 1 || lang == 'fr' ? `(s)` : ''} {lang == 'en' ? 'required' : 'requises'}</strong><br>
					{lang == 'en'
						? `Amount per ${dataset.tenantHhSellingUom} = ${coveragePrice} sq. ft.`
						: `Quantité par ${dataset.tenantHhSellingUom} = ${coveragePrice} pieds carrés`
					}<br>
					{lang == 'en'
						? `Total = ${calculatedCoverage.total.toFixed(2)} sq. ft. ${calculatedCoverage.buffer ? ` (includes ${calculatedCoverage.buffer}%)` : ''}`
						: `Total = ${calculatedCoverage.total.toFixed(2).toString().replace(/\./g, ',')} pieds carrés ${calculatedCoverage.buffer ? ` (${calculatedCoverage.buffer} % inclus)` : ''}`
					}
				</p>
				<div>
					<p class="h4 Light">
						<strong class="h3">{formatMoney(calculatedCoverage.qty * (availability.price.salePrice || availability.price.price))}</strong>
						{ lang == 'en'
							? ` for ${calculatedCoverage.qty } ${dataset.tenantHhSellingUom}${calculatedCoverage.qty > 1 ? `(s)` : ''}`
							: ` pour ${calculatedCoverage.qty} ${dataset.tenantHhSellingUom}${calculatedCoverage.qty > 1 ? `(s)` : ''}`
						}
					</p>
					{#if calculatedCoverage.qty > availability.maxQty}
						<p class="ErrorNote">
							{ lang == 'en'
								? ` Only ${availability.maxQty } ${dataset.tenantHhSellingUom}${calculatedCoverage.qty > 1 ? `(s)` : ''} left. Call your local store for details.`
								: `Il ne reste que ${availability.maxQty} ${dataset.tenantHhSellingUom}${calculatedCoverage.qty > 1 ? `(s)` : ''}. Appelez votre magasin local pour plus de détails.`
							}
						</p>
					{/if}
				</div> -->
			</section>

			
	
			<!-- <hh-add-button
				productInfo={coverageProductInfoJSON}
				buttonTitle={lang == 'en' ? `Add ${calculatedCoverage.qty} to Cart` : `Add ${calculatedCoverage.qty} to Cart`}
			>
			</hh-add-button> -->
		{/if}
	</details>
</section>

<style>
	.SquareFootageCalculator {
		margin-bottom: var(--gap);
	}
	.SquareFootageCalculator > details.Accordion-Overview {
		border: 1px solid var(--hh-grey);
		padding: calc(var(--gap) * .75) calc(var(--gap) * .5) !important;
		border-radius: 6px;
	}
	.SquareFootageCalculator .FormColumns {
		padding-bottom: calc(var(--gap) / 2) !important;
	}
	.SquareFootageAreas > label,
	.LengthWidthAreas > label {
		padding-bottom: 0 !important;
	}
	.SquareFootageAreas > button,
	.LengthWidthAreas > button {
		padding-top: calc(var(--gap) / 2);
	}
	.SquareFootageCalculator .Form > fieldset.CalculatorAdditions {
		padding-bottom: calc(var(--gap) / 2);
	}
	.SquareFootageCalculator .Form > fieldset.CalculatorAdditions > label {
		display: grid;
		grid-template-columns: auto 1fr;
		margin: 0 !important;
		padding-top: calc(var(--gap) / 2);
	}
	.SquareFootageCalculator .Form > fieldset.CalculatorAdditions > label > *:not(input[type="checkbox"]) {
		grid-column: 2/-1;
	}
	.SquareFootageCalculator form > fieldset.CalculatorAdditions > label > .RadioFlex {
		padding-top: calc(var(--gap) / 2);
		column-gap: var(--gap);
	}
	.SquareFootageCalculator form > fieldset.CalculatorAdditions >label >.RadioFlex >label {
		padding: 0 !important;
		margin: 0 !important;
		column-gap: calc(var(--gap) / 2);
	}
	.SquareFootageCalculator form > fieldset.CalculatorAdditions > label > .RadioFlex > label > input[type="radio"] {
		padding: 0 !important;
		margin: 0 !important;
	}
	.SquareFootageCalculator form button[type=submit] {
		margin-top: var(--gap) ;
	}
	/* .SquareFootageCalculator .Form > fieldset:last-of-type {
		padding-bottom: 0 !important;
	}
	.SquareFootageCalculator .Form > fieldset:last-of-type > fieldset {
		display: flex;
		column-gap: var(--gap);
		align-items: center;
	}
	.SquareFootageCalculator .Form > fieldset:last-of-type > fieldset > input {
		height: max-content;
	} */
	.SquareFootageCalculator .Calculated {
		display: flex;
		flex-direction: column;
		row-gap: var(--gap);
		margin-top: var(--gap);
	}
	.SquareFootageCalculator .Calculated p {
		padding: 0;
	}
	/* .SquareFootageCalculator .Calculated > div > p > strong {
		display: inline-block;
	} */
	.SquareFootageCalculator .Form > fieldset.LengthWidthAreas > fieldset {
		display: grid;
		grid-template-columns: 1fr auto 1fr;
		column-gap: calc(var(--gap) / 2);
		align-items: center;
	}
	.SquareFootageCalculator .Calculated > .TableKeyValues strong {
		margin-top: calc(var(--gap) / 2);
		display: block;
	}
	.SquareFootageCalculator .Calculated > .TableKeyValues small {
		color: var(--hh-dark-grey);
	}
	.SquareFootageCalculator .Calculated > .TableKeyValues tr:not(:last-of-type) {
    	vertical-align: top;
	}
	.SquareFootageCalculator .Calculated > .TableKeyValues tr:last-of-type {
		vertical-align: bottom;
	}
	.SquareFootageCalculator .Calculated > .TableKeyValues tr td:first-child {
		white-space: nowrap;
	}
	.SquareFootageCalculator .Calculated > .TableKeyValues tr td:last-child {
		white-space: wrap;
	}
	.SquareFootageCalculator .Calculated > .TableKeyValues .h3 {
		display: inline-block;
	}

</style>